import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initMetaPixel, trackPurchase } from "./metaPixel";
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { successTranslations } from '../i18n/translations';

const SuccessShop = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  const { language } = useLanguage();
  const t = createTranslator(language, successTranslations);

  useEffect(() => {
    // Simulation traitement pendant 3 secondes
    setTimeout(() => {
      setIsProcessing(false);
    }, 3000);

    // Redirection après 8 secondes
    setTimeout(() => {
      navigate('/');
    }, 8000);
  }, [navigate]);

  useEffect(() => {
    initMetaPixel();
  
    const alreadyTracked = sessionStorage.getItem("purchase_tracked_shop");
  
    if (!alreadyTracked) {
      setTimeout(() => {
        trackPurchase("shop");
        sessionStorage.setItem("purchase_tracked_shop", "true");
      }, 1500);
    }
  }, []);
  
  return (
    <section className="bg-white text-black min-h-screen flex flex-col justify-center items-center px-4">
      {isProcessing ? (
        <div className="text-center">
          <div className="spinner border-4 border-t-[#4c2f8e] border-gray-300 rounded-full h-16 w-16 mb-6 animate-spin"></div>
          <h2 className="text-2xl font-semibold text-[#4c2f8e]">{t('orderProcessing')}</h2>
          <p className="text-gray-600 mt-4">{t('paymentValidation')}</p>
        </div>
      ) : (
        <div className="text-center">
          <h1 className="text-4xl font-bold text-[#4c2f8e] mb-4">{t('orderThanks')}</h1>
          <p className="text-lg text-gray-700 mb-2">
            {t('orderEmail')}
          </p>
          <p className="text-gray-500">{t('redirectHome')}</p>
        </div>
      )}

      <style>{`
        .spinner {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
};

export default SuccessShop;
